<div class="wrapper confinement">
  <div class="back-link-container">
    <a routerLink="../.." class="back-on-mobile mat-h2 back-link">
      <mat-icon class="back-link-icon">arrow_back</mat-icon>{{ 'NAVBAR.MY_ACCOUNT' | translate }}
    </a>
  </div>
  <mat-card>
    <mat-card-title class="mat-title">{{ customTitle ?? ('WEB_READER.TITLE' | translate) }}</mat-card-title>
    <mat-card-content>
      <mat-list class="orders-list">
        @for (element of digitalContentLinks; track element) {
        <mat-list-item>
          <a
            matListItemTitle
            class="digital-content-links"
            target="_blank"
            referrerpolicy="no-referrer"
            [href]="element.url"
          >
            {{ element.label }}
          </a>
          <span matListItemLine>{{ element.info }}</span>
        </mat-list-item>
        @if (!$last) {<mat-divider />} }
      </mat-list>
    </mat-card-content>
  </mat-card>
</div>
